module.exports = __webpack_public_path__ + "static/media/b-1.4ba83a2f.jpeg";